import {
  BackSide,
  Color,
  DoubleSide,
  LineBasicMaterial,
  MeshBasicMaterial,
  MultiplyBlending,
} from '@seddi/three';

export default class Materials {
  static SRGBToLinear(value) {
    const aux = new Color();
    return aux.set(value).convertSRGBToLinear();
  }
}

Materials.Box = new MeshBasicMaterial({
  color: Materials.SRGBToLinear(0xdefafe),
  blending: MultiplyBlending,
});

Materials.BoxOutline = new LineBasicMaterial({
  color: Materials.SRGBToLinear(0x4e0fd2),
});

Materials.GarmentSeam = new LineBasicMaterial({
  color: Materials.SRGBToLinear(0xff0000),
});

Materials.Gizmo = {
  X: new MeshBasicMaterial({ color: Materials.SRGBToLinear(0xff3e6c) }),
  Y: new MeshBasicMaterial({ color: Materials.SRGBToLinear(0x77ff55) }),
  Z: new MeshBasicMaterial({ color: Materials.SRGBToLinear(0x3d67ff) }),
  XY: new MeshBasicMaterial({
    color: Materials.SRGBToLinear(0xfadc28),
    opacity: 0.5,
    side: DoubleSide,
    transparent: true,
  }),
  XZ: new MeshBasicMaterial({
    color: Materials.SRGBToLinear(0xffa2f0),
    opacity: 0.5,
    side: DoubleSide,
    transparent: true,
  }),
  ZY: new MeshBasicMaterial({
    color: Materials.SRGBToLinear(0x76f7ff),
    opacity: 0.5,
    side: DoubleSide,
    transparent: true,
  }),
};

Materials.Intersect = new MeshBasicMaterial({
  visible: false,
  wireframe: true,
  side: DoubleSide,
  transparent: true,
});

Materials.Helper = new MeshBasicMaterial({
  color: Materials.SRGBToLinear(0xffffff),
  side: BackSide,
});

Materials.LightBack = new MeshBasicMaterial({
  color: Materials.SRGBToLinear(0x222222),
});
